<template>
  <div id="app"></div>
</template>

<script>
export default {
  data() {
    this.$router.go(-1)
    return{
        
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/Kong.vue